module.exports = "/_next/static/images/associationLogo12-f980a0f8c8c0b3cab78e7fa47b75e11b.webp";